// C:\Users\CUSTOMER\Documents\GitHub\erp-transport-app\src\store\actions\unit_type_rates.js

import crud from './_crud'
import { callApi } from 'utils/api'

const entity = 'unit_type_rate'
const actions = crud(entity, 'la tarifa de tipo de unidad', 'las tarifas de tipo de unidad')

const getUnitTypes = (options) => {
  return async (dispatch, getState) => {
    const states = getState()

    const response = await callApi(`/${entity}/utils/get_unit_types`, {
      method: 'GET',
      headers: {
        Authorization: states.app.user.token,
      },
      params: options,
    })

    dispatch({
      type: `LOAD_${entity.toUpperCase()}S`,
      response: response.body,
    })

    return response.body
  }
}

const updateUnitTypeRates = (rates, news) => {
  return async (dispatch, getState) => {
    const states = getState()

    const response = await callApi(`/${entity}/utils/update_rates`, {
      method: 'PUT',
      headers: {
        Authorization: states.app.user.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ rates, news }),
      json: true,
      successMessage: 'Tarifas actualizadas correctamente'
    })

    dispatch({
      type: `UPDATE_${entity.toUpperCase()}_RATES`,
      response: response.body,
    })

    return response.body
  }
}

export default {
  ...actions,
  getUnitTypes,
  updateUnitTypeRates,
}